<!--
 * @Author: tony.zhu
 * @Date: 2025-10-15 18:23:08
 * @LastEditTime: 2025-12-03 18:57:15
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-icon_by_tooltip">
    <el-tooltip
      effect="dark"
      :placement="data.placement || 'top'"
      :content="data.label"
      :enterable="false"
      v-if="isShow"
    >
      <div
        :class="[
          'icon_class_wrap',
          data.isCopy ? 'is-copy' : '',
          data.icon ? 'filter_padding' : '',
          data.icon,
        ]"
        @click.stop="
            () => {
              isShow = false;
              $nextTick(() => {
                isShow = true;
              });
              if (data.isCopy) {
                return;
              }

              if (data.icon && data.icon.indexOf('copyIcon') >= 0) {
                const value = copyValue.replace(/<\/br>/g, '\n');
                tool.copy(value, 'textarea', _this);
              }

              $emit('on-click');
            }
          "
      >
        <img :src="require('@/components/aiChat/images/icon/' + data.icon + '.png')" class="icon ordinary"/>
        <img :src="require('@/components/aiChat/images/icon/' + data.icon + '_h.png')" class="icon hover"/>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import tool from "@/components/aiChat/utils/tbox.js";
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    copyValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShow: true,
      tool,
      _this: this
    };
  },
  methods: {},
  mounted() {
    this._this = this;
  },
  watch: {
    data: {
      handler: function (n, o) {
        if (
          this.data.className &&
          this.data.className.indexOf("iconfont icon-a-yifuzhimoren") >= 0
        ) {
          const timer = setTimeout(() => {
            let obj = {
              ...this.data,
              isCopy: false,
              className: "iconfont icon-a-fuzhimoren",
            };
            this.$emit("update:data", obj);
            this.$emit("on-change", obj);
            clearTimeout(timer);
          }, 5000);
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-icon_by_tooltip {
  .icon_class_wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 4px;
    .ordinary{
      width: 16px;
      height:16px;
      display: block;
    }
    .hover{
      width: 16px;
      height:16px;
      display: none;
    }
    &:hover{
      .ordinary{
        display: none;
      }
      .hover{
        display: block;
      }
    }
    &.is-copy {
      &:hover {
        background: #e8f3ff;
        border-radius: 8px;
        .i-class_name {
          color: #165dff;
        }
      }
    }
    &.filter_padding {
      padding: 0;
    }
  }

  .icon {
    width: 24px;
    height: 24px;
    color: #86909c;
    &:hover {
      cursor: pointer;
      color: #165dff;
    }
  }
  .i-class_name {
    color: #86909c;
    font-size: 16px;
    cursor: pointer;
  }

  .icon-a-shuaxinmoren {
    font-size: 26px;
    line-height: 1;
  }
  .iconfont {
    font-size: 26px;
    line-height: 1;
  }
}
</style>